var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25.8px",
    fill: "#E84B37",
    height: "25.8px",
    viewBox: "0 0 25.8 25.8",
    style: {
      enableBackground: "new 0 0 25.8 25.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,7.6h-3.4V6c0-0.3-0.1-0.6-0.4-0.7c-0.2-0.1-0.4-0.2-0.6-0.1h-3c-0.5,0-0.9,0.4-0.9,0.9v1.6H7 C6.8,7.6,6.6,7.8,6.6,8S6.8,8.4,7,8.4h0.7L9,20.1c0,0.4,0.4,0.7,0.7,0.7h6.4c0.4,0,0.7-0.4,0.7-0.6l1.4-11.8h0.7 c0.2,0,0.4-0.2,0.4-0.4S19,7.6,18.8,7.6z M11.2,6c0-0.1,0-0.1,0.1-0.1h3.1c0,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1v1.6h-3.5V6z  M16.1,20l-6.3,0L8.4,8.4h9L16.1,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.14aaeac18e808b22a6260a7939bf1f5a.svg";
export { ForwardRef as ReactComponent };